import React, { useEffect, useState } from "react";
import { isNull } from "lodash";
//import { Box, Typography, IconButton, Tooltip, Checkbox, Pagination } from "@mui/material";
//import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
//import DifferenceIcon from "@mui/icons-material/Difference";
//import ComparisonModal from "./ComparisonModal";
import QuotationDetailsModal from "./QuotationDetailsModal";
//import StatusChip from "@/app/features/tender/components/view/Status";
import { useMediaQuery } from "react-responsive";
import StatusOrderChip from "@/app/global-components/StatusOrderChip";
import TableComponent from "@/app/global-components/table";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
//import useLobby from "@/hooks/use-lobby";
import useOffer from "@/hooks/useTender";

interface TenderQuotation {
  tender: { title: string; id: string; status: string };
  id: string;
  status: string;
  products: Product[];
  deliverDays: number;
  DeadLineDate: string;
  paymentMethod: string;
  contactMethod: string;
  DeliveryMethod: string;
  company: {
    nameAr: string;
    website: string;
    address: string;
    contactInfo: string;
  };
}
interface Product {
  id?: string;
  unitName: string;
  quantity: number;
  unitPrice: number;
  attachment?: File | null;
  notice?: string;
  image?: { url: string };
}
const TrenderQuatationsList: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  const { getOffers } = useOffer();
  // const { getListtenderQuotations } = useLobby();
  const [listOffers, setListOffers] = useState<any>([]);
  //const [selectedOffers, setSelectedOffers] = useState<TenderQuotation[]>([]);
  //const [currentPage, setCurrentPage] = useState(1);
  //const itemsPerPage = 10;

  //const [openModal, setOpenModal] = useState(false);
  const [selectedQuotation, setSelectedQuotation] =
    useState<TenderQuotation | null>(null);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  useEffect(() => {
    const fetchQuotations = async () => {
      try {
        const response = await getOffers("Opened");
        if (response) {
          setListOffers(response.data || []);
        }
      } catch (error) {
        console.error("Error fetching quotations:", error);
      }
    };

    fetchQuotations();
  }, []);
  /*
  const handlePageChange = (_: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
  };

  const handleCheckboxChange = (item: TenderQuotation) => {
    setSelectedOffers((prevSelected) => {
      const isSelected = prevSelected.some((offer) => offer.id === item.id);
      return isSelected
        ? prevSelected.filter((offer) => offer.id !== item.id)
        : prevSelected.length < 2
        ? [...prevSelected, item]
        : prevSelected;
    });
  };*/

  // const handleCompare = () => {
  //   if (selectedOffers.length === 2) setOpenModal(true);
  // };

  // const handleCloseModal = () => {
  //   setOpenModal(false);
  // };

  const handleViewDetails = (quotation: TenderQuotation) => {
    setSelectedQuotation(quotation);
  };

  const handleCloseDetailsModal = () => {
    setSelectedQuotation(null);
  };

  //const startIndex = (currentPage - 1) * itemsPerPage;
  //const paginatedOffers = listOffers.slice(startIndex, startIndex + itemsPerPage);
  //const paginatedOffers = listOffers;
  //2025-01-15
  const columns = [
    {
      title: t("navigation.Opportunity"),
      field: "tender.title",
      render: (row: any) => `${row.title}`,
      hideOnMobile: true,
    },
    // {
    //   title: t("checkout.fields.company"),
    //   field: "company.nameAr",
    //   render: (row: any) => `${row.company.nameAr}`,
    // },
    {
      title: t("delivery.time"),
      field: "DeadLineDate",
      render: (row: any) => `${row.DeadLineDate ?? 0} ${t("time.days")}`,
      hideOnMobile: true,
    },
    {
      title: t("tender.value"),
      field: "products",
      render: (row: any) => row.value,
    },
    {
      title: t("orders.fields.status"),
      field: "status",
      render: (row: any) => (
        <StatusOrderChip status={isNull(row.status) ? "Opened" : row.status} />
      ),
    },
  ];
  //
  return (
    <div
      className="bg-white py-4 rounded-xl mx-4 md:px-10 relative"
      style={{ direction: "rtl" }}
    >
      <div className="text-2xl font-bold text-zinc-400 text-center">
        {t("navigation.Quotations")}
      </div>
      <TableComponent
        columns={columns}
        data={listOffers}
        rowKeyField="id"
        maxHeight={isMobile ? 500 : 300}
        onRowClick={handleViewDetails}
        isMobile={isMobile}
      />
      {/* {selectedQuotation && (
        <QuotationDetailsModal
          open={!!selectedQuotation}
          onClose={handleCloseDetailsModal}
          quotation={selectedQuotation}
          offerStatus={
            isNull(selectedQuotation.tender)
              ? ""
              : selectedQuotation.tender.status
          }
        />
      )} */}
      {/*<div className="mt-8 overflow-x-scroll no-scrollbar">
  <div className={`flex max-h-[${isMobile?500:300}px] flex-col gap-2`}>
      <div className="border-b border-gray-200 grid grid-cols-5">
                <div className="p-4 text-start font-bold min-w-32">{t("navigation.opportunity")}</div>
                <div className="p-4 text-start font-bold">{t("checkout.fields.company")}</div>
                <div className="p-4 text-start font-bold">مدة التسليم</div>
                <div className="p-4 text-start font-bold">{t("tender.fields.value")}</div>
                <div className="p-4 text-start font-bold">{t("orders.fields.status")}</div>
      </div>
      <div className={`flex flex-col h-[${isMobile?450:250}px] no-scrollbar overflow-y-scroll px-2 gap-2`}>
      {
      !isEmpty(paginatedOffers) ? 
       paginatedOffers.map((item, index) => (
         <div
         onClick={() => handleViewDetails(item)}
         key={index}
         className="grid grid-cols-5 items-center cursor-pointer hover:scale-[1.01] border-green-300 !rounded-2xl"
       >
         <div className="p-4 min-w-32">
         {item.tender.title}
         </div>
         <div className="p-4">{item.company.nameAr}</div>
         <div className="p-4 flex items-center gap-2">
         {item.DeadLineDate ?? 0} ${t("time.days")}
         </div>
         <div className="p-4 flex items-center gap-2">
         {!isEmpty(item.products)
                  ? item.products
                      .reduce(
                        (acc, product) => acc + product.quantity * product.unitPrice,
                        0
                      )
                      .toFixed(2)
                  : "0.00"}
         </div>
         <div className="p-4">
         <StatusOrderChip
             status={isNull(item.status) ? "Opened" : item.status}
           />
         </div>
       </div>
      ))
      :""
    }
      </div>
  </div>
  </div> */}
      {/*openModal && (
    <ComparisonModal
      open={openModal}
      onClose={handleCloseModal}
      offers={selectedOffers}
    />
  )*/}

      {selectedQuotation && (
        <QuotationDetailsModal
          open={!!selectedQuotation}
          onClose={handleCloseDetailsModal}
          quotation={selectedQuotation}
          offerStatus={
            isNull(selectedQuotation.tender) ? "" : selectedQuotation.status
          }
        />
      )}
    </div>
  );
};

export default TrenderQuatationsList;
